<template>
  <div class="saddle-step-two">
    <v-layout
      justify-space-between
      wrap
    >
      <v-flex
        sm6
        px-4
      >
        <v-switch
          v-model="form.idc_shapes"
          hide-details
          label="Formes :"
          class="title"
          @change="clearShapesFields"
        />
        <v-layout wrap>
          <v-radio-group
            v-model="form.shapes_parts"
            hide-details
            row
            class="mb-2"
            :disabled="!form.idc_shapes"
          >
            <v-radio
              label="Parite 1"
              value="1PART"
            />
            <v-radio
              class="ml-10"
              label="Partie 2"
              value="2PARTS"
            />
          </v-radio-group>

          <div class="cadre mt-2 mb-3">
            <v-flex
              v-if="form.shapes_parts == '1PART' || form.shapes_parts == null"
              class="left-schema"
            >
              <div class="content mt-8">
                <div class="img-container">
                  <img src="@/assets/img/schema_selle_2a.svg">
                  <v-text-field
                    v-model="form.part1_a"
                    v-validate="'numeric|max:4'"
                    data-vv-name="(Schéma) Partie 1 A"
                    :class="{ error: errors.has('(Schéma) Partie 1 A') }"
                    outlined
                    type="number"
                    style="top: 14.3%;left: 0.2%;"
                    height="100%"
                    :disabled="!form.idc_shapes"
                  />
                  <v-text-field
                    v-model="form.part1_b"
                    v-validate="'numeric|max:4'"
                    data-vv-name="(Schéma) Partie 1 B"
                    :class="{ error: errors.has('(Schéma) Partie 1 B') }"
                    outlined
                    type="number"
                    style="top: 43.3%;left: 67.2%;"
                    height="100%"
                    :disabled="!form.idc_shapes"
                  />
                </div>
              </div>
            </v-flex>

            <v-flex
              v-if="form.shapes_parts == '2PARTS'"
              class="right-schema"
            >
              <div class="content mt-2 mb-3">
                <div class="img-container">
                  <img src="@/assets/img/schema_selle_2b.svg">
                  <v-text-field
                    v-model="form.part2_a"
                    v-validate="'numeric|max:4'"
                    data-vv-name="(Schéma) Partie 2 A"
                    :class="{ error: errors.has('(Schéma) Partie 2 A') }"
                    outlined
                    type="number"
                    style="top: 34.5%;left: 0.1%;"
                    height="100%"
                    :disabled="!form.idc_shapes"
                  />
                  <v-text-field
                    v-model="form.part2_b"
                    v-validate="'numeric|max:4'"
                    data-vv-name="(Schéma) Partie 2 B"
                    :class="{ error: errors.has('(Schéma) Partie 2 B') }"
                    outlined
                    type="number"
                    style="top: 34.5%;left: 67.2%;"
                    height="100%"
                    :disabled="!form.idc_shapes"
                  />
                </div>
              </div>
              <v-select
                v-model="form.shapes_fixing"
                :items="dropdowns.shapes_fixing"
                item-text="label"
                item-value="value"
                label="Amovible"
                filled
                clearable
                :disabled="!form.idc_shapes"
              />
            </v-flex>
          </div>
        </v-layout>
      </v-flex>

      <v-flex
        sm6
        px-4
      >
        <h3 class="mb-3">
          Finition :
        </h3>
        <v-textarea
          v-model="form.shapes_comments"
          filled
          name="Ajouter un commentaire"
          label="Ajouter un commentaire"
          counter="50"
          maxlength="50"
        />
      </v-flex>

      <v-flex
        sm6
        px-4
      >
        <h3 class="mb-3">
          Ailettes d’abduction :
        </h3>
        <v-btn
          block
          class="mb-3"
          @click="sketchClick"
        >
          Nouveau Croquis
        </v-btn>
      </v-flex>

      <v-flex
        sm6
        px-4
      >
        <h3 class="mb-3">
          Forme :
        </h3>
        <v-textarea
          v-model="form.form_comment"
          filled
          name="Ajouter un commentaire"
          label="Ajouter un commentaire"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SeatStepTwo",
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      dropdowns: "dropdowns/getSeatOptions"
    })
  },
  created() {
    this.$validator = this.parentValidator;
  },
  methods: {
    sketchClick() {
      this.$emit("sketch-click");
    },

    // Clear shapes fields
    clearShapesFields() {
      this.form.part1_a = null;
      this.form.part1_b = null;
      this.form.part2_a = null;
      this.form.part2_b = null;
      this.form.shapes_parts = null;
      this.form.shapes_fixing = null;
    }
  }
};
</script>

<style lang="scss">
.saddle-step-two {
  .content {
    display: flex;
    // min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        height: 100%;
        width: 100%;
        // min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 32.6%;
        height: 18.4%;
        @media (max-width: 800px) {
          height: 18.4%;
        }
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
  .canvas-container {
    width: 100%;
    height: 600px;
    max-height: 40vh;
    display: flex;
    .canvas-item {
      height: 100%;
      width: 100%;
      background-color: purple;
    }
  }
  .cadre {
    background-color: rgb(235, 245, 245);
    height: 210px;
    width: 300px;

    padding: 10px;
    border-radius: 4px;
  }
}
</style>
